exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-2918657e]{border-collapse:collapse;width:100%}td[data-v-2918657e],th[data-v-2918657e]{border:1px solid #ddd;text-align:left;padding:8px}tr[data-v-2918657e]:nth-child(2n){background-color:#eaeaea}tr[data-v-2918657e]:hover{background-color:#eaeaea;cursor:pointer}img[data-v-2918657e]{height:100px;width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2918657e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/providerRow.vue
// module id = 160
// module chunks = 0